import React, { Component } from 'react';
import SocialLinks from './SocialLinks';
import style from './HeaderSocial.module.scss';

class HeaderSocial extends Component {
  handleChange = () => {
    this.props.handleSocialExpanded();
  };

  render() {
    const { isSocialExpanded, mainNavColor } = this.props;

    return (
      <li
        className={`js-navItem ${style.socialWrapper} ${
          isSocialExpanded ? style.isExpanded : ''
        }`}
      >
        <a
          className={`${style.socialTrigger} ${
            mainNavColor === 'white' ? style.whiteTrigger : ''
          }`}
          onClick={this.handleChange}
        >
          Social
        </a>

        <div className={style.socialLinksWrapper}>
          <SocialLinks
            mainNavColor={mainNavColor}
            data={this.props.settingsContent.social}
          />
        </div>

        <a
          className={`${style.socialClose} ${
            mainNavColor === 'white' ? style.whiteClose : ''
          }`}
          onClick={this.handleChange}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <title>Plus Icon</title>
            <polygon
              fillRule="evenodd"
              points="13 11.204 24.5 11.204 24.5 13.204 13 13.204 13 24.204 11 24.204 11 13.204 0 13.204 0 11.204 11 11.204 11 0 13 0"
            />
          </svg>
        </a>
      </li>
    );
  }
}

export default HeaderSocial;



// WEBPACK FOOTER //
// ./src/components/global/HeaderSocial.js